import { makeRequest } from './api';

export const requestWithState = async ({
  url,
  method = 'GET',
  data = null,
  customBaseURL = null,
  onStart = () => {},
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {},
}) => {
  try {
    onStart();
    const response = await makeRequest(url, method, data, customBaseURL);
    onSuccess(response);
    return response;
  } catch (error) {
    // // console.log(error, "error in requestWithState");
    onError(error); // This now gets actual backend error (like your 401 JSON)
    throw error;
  } finally {
    onFinally();
  }
};
